import { bindActionCreators } from '@reduxjs/toolkit';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { eventTypes, otherEvents } from '../../shared/tracking';

import { getItem } from '../../selectors/item';

import MessageToRetailerModal from './message-to-retailer-modal';

import { hideMessageModal } from '../../actions/event';
import { mapVehicleData, track } from '../../actions/tracking';

const MessageModal = () => {
  const item = useSelector(getItem);
  const dispatch = useDispatch();

  const actions = bindActionCreators(
    {
      track,
      hideMessageModal,
    },
    dispatch,
  );

  useEffect(() => {
    actions.track(eventTypes.OTHER, {
      item: mapVehicleData(item, true),
      conversionType: otherEvents.MESSAGE_INITATED,
    });

    return () => {
      actions.track(eventTypes.OTHER, {
        item: mapVehicleData(item, true),
        conversionType: otherEvents.MESSAGE_MODAL_CLOSE,
      });
    };
  }, []);

  return <MessageToRetailerModal onClose={actions.hideMessageModal} />;
};

export default MessageModal;
